import "bootstrap/dist/css/bootstrap.min.css";
import React, { lazy, Suspense, useEffect } from "react";
import { BrowserRouter, Route, Navigate, Routes } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import ReactGA from "react-ga4";
import "./App.css";
import Spinner from "./components/Loading&Spinners/Spinner";
import Home from "./components/Layout/Home";
import NewPage from "./components/Layout/NewPage";
import MerakiHome from "./components/Layout/MerakiHome";
import CpuPlayer from "./tic-tac-toe/pages/CpuPlayer";
import CreateGame from "./tic-tac-toe/pages/CreateGame";
import MyProfile from "./components/Layout/Profile";
import GameBoard from "./tic-tac-toe/pages/GameBoard";
import ChatAI from "./components/ChatAI/ChatAI";
import GamePage from "./Tick_Tack_New/Game";
import SocialHome from "./SocialNow(Beta)/SocialHome";
//bottom tabs
import BottomTabs from "./components/BottomTabs/BottomTabs";
import "react-toastify/dist/ReactToastify.css";
import OTP from "./NewLogin/OTP";
import Login from "./NewLogin/Login";
import { ToastContainer, toast } from "react-toastify";
import TokenChecker from "./utils/checkTokenExpiration";

const AuthenticatedHome = lazy(() =>
  import("./components/Layout/AuthenticatedHome")
);
const AuthenticatedGames = lazy(() =>
  import("./components/Layout/AuthenticatedGames")
);
const AuthenticatedGamesAll = lazy(() =>
  import("./components/Layout/AuthenticatedGamesAll")
);
const LoginOtpPage = lazy(() => import("./components/Layout/Login-Otp"));
const LoginPage = lazy(() => import("./components/Layout/LoginPage"));
const OTPPage = lazy(() => import("./components/Layout/OTPPage"));
const ComponentToDisplay = lazy(() =>
  import("./components/GamesComponets/ComponentToDisplay")
);
const ComponentToDisplayAllGames = lazy(() =>
  import("./components/GamesComponets/ComponentToDisplayAllGames")
);
const UnsubscribePage = lazy(() =>
  import("./components/Layout/UnsubscribePage")
);
const Action = lazy(() => import("./components/Layout/Action"));
const Adventure = lazy(() => import("./components/Layout/Adventure"));
const Racing = lazy(() => import("./components/Layout/Racing"));
const Sports = lazy(() => import("./components/Layout/Sports"));
const Strategy = lazy(() => import("./components/Layout/Strategy"));
const Favorites = lazy(() => import("./components/Layout/Favorites"));
const DownloadGames = lazy(() => import("./components/Layout/DownloadGames"));
const Puzzle = lazy(() => import("./components/Layout/Puzzle"));
const Casual = lazy(() => import("./components/Layout/Casual"));
const Memory = lazy(() => import("./components/Layout/Memory"));
const TwoPlayer = lazy(() => import("./components/Layout/TwoPlayer"));
const MostPopular = lazy(() => import("./components/Layout/MostPopular"));
const NewArrivals = lazy(() => import("./components/Layout/NewArrivals"));
const Policy = lazy(() => import("./components/Layout/Policy"));
const MostAction = lazy(() => import("./components/Layout/MostAction"));
const MostAdventure = lazy(() => import("./components/Layout/MostAdventure"));
const MostSports = lazy(() => import("./components/Layout/MostSports"));
const MostRacing = lazy(() => import("./components/Layout/MostRacing"));
const MostStrategy = lazy(() => import("./components/Layout/MostStrategy"));
const MostPuzzle = lazy(() => import("./components/Layout/MostPuzzle"));
const MostCasual = lazy(() => import("./components/Layout/MostCasual"));
const MostMemory = lazy(() => import("./components/Layout/MostMemory"));
const MostTwoPlayer = lazy(() => import("./components/Layout/MostTwoPlayer"));

const NewArrivalAction = lazy(() =>
  import("./components/Layout/NewArrivalAction")
);
const NewArrivalSports = lazy(() =>
  import("./components/Layout/NewArrivalSports")
);
const NewArrivalAdventure = lazy(() =>
  import("./components/Layout/NewArrivalAdventure")
);
const NewArrivalRacing = lazy(() =>
  import("./components/Layout/NewArrivalRacing")
);
const NewArrivalStrategy = lazy(() =>
  import("./components/Layout/NewArrivalStrategy")
);
const NewArrivalPuzzle = lazy(() =>
  import("./components/Layout/NewArrivalPuzzle")
);
const NewArrivalCasual = lazy(() =>
  import("./components/Layout/NewArrivalCasual")
);
const NewArrivalMemory = lazy(() =>
  import("./components/Layout/NewArrivalMemory")
);
const NewArrivalTwoPlayer = lazy(() =>
  import("./components/Layout/NewArrivalTwoPlayer")
);
const ProfileView = lazy(() => import("./components/Layout/ProfileView"));

// ReactGA.initialize("G-48E603Q673");

const ProtectedRoute = ({ children }) => {
  return localStorage.getItem("jwt_j") == null ? (
    <Navigate to="/index.php" />
  ) : (
    children
  );
};

function App() {
  //init the Hook
  const hiddenRoutes = ["/login", "/OTP", "/index.php", "/otp"];
  const location = useLocation();
  //
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const uniqRef = urlParams.get("uniqref");

  // ReactGA.send({ hitType: "pageview", page: window.location.pathname });

  return (
    <>
      <ToastContainer />
      <TokenChecker />
      <Helmet />
      <Suspense fallback={<Spinner />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/TickTokHome" element={<AuthenticatedHome />} />

          <Route path="/meraki-home" element={<MerakiHome />} />
          <Route path="/home" element={<AuthenticatedHome />} />
          <Route
            path="/game-component"
            element={
              <ProtectedRoute>
                <ComponentToDisplay />
              </ProtectedRoute>
            }
          />
          <Route
            path="/game-component1"
            element={
              <ProtectedRoute>
                <ComponentToDisplayAllGames />
              </ProtectedRoute>
            }
          />

          <Route
            path="/games"
            element={
              <ProtectedRoute>
                <AuthenticatedGames />
              </ProtectedRoute>
            }
          />
          <Route path="/chat-ai" element={<ChatAI />} />
          <Route
            path="/games-all"
            element={
              <ProtectedRoute>
                <AuthenticatedGamesAll />
              </ProtectedRoute>
            }
          />
          <Route
            path="/strategy"
            element={
              <ProtectedRoute>
                <Strategy />
              </ProtectedRoute>
            }
          />
          <Route
            path="/sports"
            element={
              <ProtectedRoute>
                <Sports />
              </ProtectedRoute>
            }
          />
          <Route
            path="/racing"
            element={
              <ProtectedRoute>
                <Racing />
              </ProtectedRoute>
            }
          />
          <Route
            path="/adventure"
            element={
              <ProtectedRoute>
                <Adventure />
              </ProtectedRoute>
            }
          />
          <Route
            path="/action"
            element={
              <ProtectedRoute>
                <Action />
              </ProtectedRoute>
            }
          />
          <Route
            path="/puzzle"
            element={
              <ProtectedRoute>
                <Puzzle />
              </ProtectedRoute>
            }
          />
          <Route
            path="/casual"
            element={
              <ProtectedRoute>
                <Casual />
              </ProtectedRoute>
            }
          />
          <Route
            path="/memory"
            element={
              <ProtectedRoute>
                <Memory />
              </ProtectedRoute>
            }
          />
          <Route
            path="/twoplayer"
            element={
              <ProtectedRoute>
                <TwoPlayer />
              </ProtectedRoute>
            }
          />
          <Route
            path="/favorites"
            element={
              <ProtectedRoute>
                <Favorites />
              </ProtectedRoute>
            }
          />
          <Route
            path="/SocialHome"
            element={
              <ProtectedRoute>
                <SocialHome />
              </ProtectedRoute>
            }
          />
          <Route
            path="/downloadnow"
            element={
              <ProtectedRoute>
                <DownloadGames />
              </ProtectedRoute>
            }
          />
          <Route
            path="/GamePage"
            element={
              <ProtectedRoute>
                <GamePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/mostpopular"
            element={
              <ProtectedRoute>
                <MostPopular />
              </ProtectedRoute>
            }
          />
          <Route
            path="/newarrivals"
            element={
              <ProtectedRoute>
                <NewArrivals />
              </ProtectedRoute>
            }
          />
          <Route
            path="/mostaction"
            element={
              <ProtectedRoute>
                <MostAction />
              </ProtectedRoute>
            }
          />
          <Route
            path="/mostsports"
            element={
              <ProtectedRoute>
                <MostSports />
              </ProtectedRoute>
            }
          />
          <Route
            path="/mostadventure"
            element={
              <ProtectedRoute>
                <MostAdventure />
              </ProtectedRoute>
            }
          />
          <Route
            path="/mostracing"
            element={
              <ProtectedRoute>
                <MostRacing />
              </ProtectedRoute>
            }
          />
          <Route
            path="/moststrategy"
            element={
              <ProtectedRoute>
                <MostStrategy />
              </ProtectedRoute>
            }
          />
          <Route
            path="/mostpuzzle"
            element={
              <ProtectedRoute>
                <MostPuzzle />
              </ProtectedRoute>
            }
          />
          <Route
            path="/mostcasual"
            element={
              <ProtectedRoute>
                <MostCasual />
              </ProtectedRoute>
            }
          />
          <Route
            path="/mostmemory"
            element={
              <ProtectedRoute>
                <MostMemory />
              </ProtectedRoute>
            }
          />
          <Route
            path="/mosttwoplayer"
            element={
              <ProtectedRoute>
                <MostTwoPlayer />
              </ProtectedRoute>
            }
          />
          <Route
            path="/newarrivalaction"
            element={
              <ProtectedRoute>
                <NewArrivalAction />
              </ProtectedRoute>
            }
          />
          <Route
            path="/newarrivalsport"
            element={
              <ProtectedRoute>
                <NewArrivalSports />
              </ProtectedRoute>
            }
          />
          <Route
            path="/newarrivaladventure"
            element={
              <ProtectedRoute>
                <NewArrivalAdventure />
              </ProtectedRoute>
            }
          />
          <Route
            path="/newarrivalracing"
            element={
              <ProtectedRoute>
                <NewArrivalRacing />
              </ProtectedRoute>
            }
          />
          <Route
            path="/tic-game"
            element={
              <ProtectedRoute>
                <CreateGame />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Cpu"
            element={
              <ProtectedRoute>
                <CpuPlayer />
              </ProtectedRoute>
            }
          />
          <Route
            path="/MyProfile"
            element={
              <ProtectedRoute>
                <MyProfile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/game/:gameId"
            element={
              <ProtectedRoute>
                <GameBoard />
              </ProtectedRoute>
            }
          />
          {/* game routes */}
          {/* <Route path="/CpuPlayer" exact element={<CpuPlayer />} />
                    <Route path="/tic-game" element={<CreateGame />} /> */}
          {/* <Route path="/profile" exact element={<Profile />} /> */}
          {/* <Route path="/game/:gameId" element={<GameBoard />} /> */}
          {/* game routes */}
          <Route
            path="/newarrivalstrategy"
            element={
              <ProtectedRoute>
                <NewArrivalStrategy />
              </ProtectedRoute>
            }
          />
          <Route
            path="/newarrivalpuzzle"
            element={
              <ProtectedRoute>
                <NewArrivalPuzzle />
              </ProtectedRoute>
            }
          />
          <Route
            path="/newarrivalcasual"
            element={
              <ProtectedRoute>
                <NewArrivalCasual />
              </ProtectedRoute>
            }
          />
          <Route
            path="/newarrivalmemory"
            element={
              <ProtectedRoute>
                <NewArrivalMemory />
              </ProtectedRoute>
            }
          />
          <Route
            path="/newarrivaltwoplayer"
            element={
              <ProtectedRoute>
                <NewArrivalTwoPlayer />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile-view"
            element={
              <ProtectedRoute>
                <ProfileView />
              </ProtectedRoute>
            }
          />
          <Route path="/policy" element={<Policy />} />
          <Route path="/index.php" element={<Login />} />
          <Route path="/login-otp" element={<LoginOtpPage />} />
          <Route path="/otphandler" element={<OTP />} />
          <Route path="/otphandler-he" element={<OTP />} />
          <Route path="/OTP" element={<OTP />} />
          <Route path="/unsubscribe" element={<UnsubscribePage />} />
          <Route
            path="/noetic_jazz_ads.php"
            element={
              <Navigate to={`/index.php?vinfo=${uniqRef}:noetic_jazz_ads`} />
            }
          />
          <Route
            path="/2m1i.php"
            element={<Navigate to={`/index.php?vinfo=${uniqRef}:2m1i`} />}
          />
          <Route
            path="/tiktok.php"
            element={<Navigate to={`/index.php?vinfo=${uniqRef}:tiktok`} />}
          />
          <Route
            path="/2m3i.php"
            element={<Navigate to={`/index.php?vinfo=${uniqRef}:2m3i`} />}
          />
          <Route
            path="/2m4i.php"
            element={<Navigate to={`/index.php?vinfo=${uniqRef}:2m4i`} />}
          />
          <Route
            path="/2m5i.php"
            element={<Navigate to={`/index.php?vinfo=${uniqRef}:2m5i`} />}
          />
          <Route
            path="/2m6i.php"
            element={<Navigate to={`/index.php?vinfo=${uniqRef}:2m6i`} />}
          />
          <Route
            path="/2m15i.php"
            element={<Navigate to={`/index.php?vinfo=${uniqRef}:2m15i`} />}
          />
          <Route
            path="/2m7i.php"
            element={<Navigate to={`/index.php?vinfo=${uniqRef}:2m7i`} />}
          />
          <Route
            path="/4m20i.php"
            element={<Navigate to={`/index.php?vinfo=${uniqRef}:4m20i`} />}
          />
          <Route
            path="/2m9i.php"
            element={<Navigate to={`/index.php?vinfo=${uniqRef}:2m9i`} />}
          />
          <Route
            path="/4m51i.php"
            element={<Navigate to={`/index.php?vinfo=${uniqRef}:4m51i`} />}
          />
          <Route
            path="/2m13i.php"
            element={<Navigate to={`/index.php?vinfo=${uniqRef}:2m13i`} />}
          />
          <Route
            path="/2m18i.php"
            element={<Navigate to={`/index.php?vinfo=${uniqRef}:2m18i`} />}
          />
          <Route
            path="/4m32i.php"
            element={<Navigate to={`/index.php?vinfo=${uniqRef}:4m32i`} />}
          />
          <Route
            path="/noetic_google_ads.php"
            element={
              <Navigate to={`/index.php?vinfo=${uniqRef}:noetic_google_ads`} />
            }
          />
          <Route
            path="/mobipium.php"
            element={<Navigate to={`/index.php?vinfo=${uniqRef}:mobipium`} />}
          />
          <Route
            path="/propellerads.php"
            element={
              <Navigate to={`/index.php?vinfo=${uniqRef}:propellerads`} />
            }
          />
          <Route
            path="/Innomovil.php"
            element={<Navigate to={`/index.php?vinfo=${uniqRef}:Innomovil`} />}
          />
          <Route
            path="/goldengoose.php"
            element={
              <Navigate to={`/index.php?vinfo=${uniqRef}:goldengoose`} />
            }
          />
          <Route
            path="/mobikok.php"
            element={<Navigate to={`/index.php?vinfo=${uniqRef}:mobikok`} />}
          />
          <Route
            path="/mobplus.php"
            element={<Navigate to={`/index.php?vinfo=${uniqRef}:mobplus`} />}
          />
          <Route path="*" element={<Navigate to="/index.php" />} />
          {/* Show BottomTabs only if the current route is NOT in hiddenRoutes */}
          {/* {!hiddenRoutes.includes(location.pathname) && <BottomTabs />} */}
        </Routes>
      </Suspense>
    </>
  );
}

export default App;
